
"use client";

import { AnimatePresence, domAnimation, LazyMotion } from "motion/react";
import * as m from "motion/react-m";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";

export const ClientOnly = ({
  children,
  fallback,
  fadeInDuration = 0.5,
  className,
}: {
  children: ReactNode;
  fallback?: ReactNode;
  fadeInDuration?: number;
  className?: string;
}) => {
  const [clientReady, setClientReady] = useState<boolean>(false);

  useEffect(() => {
    setClientReady(true);
  }, []);

  const Comp = fadeInDuration ? m.div : "div";

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {clientReady ? (
          <Comp
            data-testid="client-only"
            {...(fadeInDuration
              ? {
                  initial: { opacity: 0 },
                  animate: { opacity: 1 },
                  transition: { duration: fadeInDuration },
                }
              : {})}
            className={className}
          >
            {children}
          </Comp>
        ) : (
          fallback || null
        )}
      </AnimatePresence>
    </LazyMotion>
  );
};
